// ── Auth storage helpers ─────────────────────────────────────────────────────
export const getUser       = ()    => { try { return JSON.parse(localStorage.getItem("loggedinUserDetails")); } catch { return null; } };
export const setUser       = (u)   => localStorage.setItem("loggedinUserDetails", JSON.stringify(u));
export const getIsAuth     = ()    => localStorage.getItem("isAuthenticated") === "true";
export const setIsAuth     = (v)   => localStorage.setItem("isAuthenticated", String(v));
export const clearAuth     = ()    => { localStorage.removeItem("isAuthenticated"); localStorage.removeItem("loggedinUserDetails"); };

// ── Token helpers (for JWT compat) ───────────────────────────────────────────
export const getToken      = ()    => localStorage.getItem("token");
export const setToken      = (t)   => localStorage.setItem("token", t);
export const removeToken   = ()    => localStorage.removeItem("token");
